import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icon, type IconName } from '@/components/common/Icon';

export interface AttentionRow {
  key: string;
  to: string;
  primary: string;
  secondary: string;
  detail: string | null;
  actions: ReactNode;
}

interface AttentionSectionBlockProps {
  iconName: IconName;
  title: string;
  total: number;
  rows: AttentionRow[];
  footer: ReactNode;
}

export function AttentionSectionBlock({
  iconName,
  title,
  total,
  rows,
  footer,
}: AttentionSectionBlockProps) {
  return (
    <section className="border border-zooborder rounded-xl p-3 flex flex-col">
      <div className="flex items-center gap-2 mb-2">
        <span className="w-7 h-7 rounded-lg bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
          <Icon name={iconName} />
        </span>
        <h3 className="text-[13px] font-bold text-zooindigo flex-1 min-w-0 truncate">{title}</h3>
        <span className="min-w-[22px] h-[22px] px-1.5 flex items-center justify-center rounded-full bg-zooprimary text-zoowhite text-[11px] font-bold shrink-0">
          {total}
        </span>
      </div>
      <ul className="divide-y divide-zooborder flex-1">
        {rows.map(function renderRow(row) {
          return (
            <li key={row.key}>
              <Link
                to={row.to}
                className="block py-2 rounded-lg hover:bg-zoovpalelavender hover:bg-opacity-40 px-1 -mx-1 transition-colors"
              >
                <span className="block text-[13px] font-semibold text-zooindigo truncate">
                  {row.primary}
                </span>
                <span className="block text-[11px] text-zoomuted truncate">{row.secondary}</span>
                {row.detail === null ? null : (
                  <span className="block text-[12px] text-zooindigo italic mt-0.5 line-clamp-2">
                    {row.detail}
                  </span>
                )}
              </Link>
              {row.actions}
            </li>
          );
        })}
      </ul>
      {footer}
    </section>
  );
}
